import { useApiCall } from "@jane/lib/src/api"
import { Card } from "@jane/lib/src/components/Card"
import { Button } from "@jane/lib/src/components/form/Button";
import { useToasts } from "@jane/lib/src/toasts/toasts";
import React, {ReactNode, useState} from "react"
import {config} from "../config";
import {Input} from "@jane/lib/src/components/form/Input";

export default function TestMessageForm(props: {subject: string}): ReactNode {
  const [message, setMessage] = useState<string|null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const { employees } = useApiCall(config)
  const { showToast } = useToasts()
  async function save() {
    if (message !== null) {
      await employees.sendTestNotification(props.subject, message)
        .then(() => {
          showToast('Testbericht verstuurd', message.substring(0, 100))
          setMessage(null)
        }).catch((_) => {
          showToast('Error', 'Testbericht niet verzonden')
        })
    }
  }
  return <Card title={"Testbericht sturen"} id={"test-message"}>
    { message === null ? <>
      <p className={"text-sm mb-4"}>
        Je kunt deze medewerker een testbericht sturen vanuit de MiepApp.
      </p>
      <Button type={'primary'} size={'sm'} onClick={() => setMessage('')} text={'Nieuw testbericht'} />
    </> : <>
      <Input type={'textarea'} label={'Bericht'} value={message ?? ''} onChange={(v) => setMessage(v)} placeholder={'Bericht...'} />
      <div className={'flex items-center space-x-3 mt-4'}>
        <Button type={'primary'} size={'sm'} onClick={save} disabled={ isLoading || !message } text={'Bericht versturen'} />
        <Button type={'secondary'} size={'sm'} onClick={() => setMessage(null)} text={'Annuleren'} />
      </div>
    </>}
  </Card>
}
